/**
 * localStorage wrapper for calculator preferences and recent calculations.
 */

const STORAGE_PREFIX = "salarylab_"
const MAX_RECENT = 5

/**
 * Get a stored preference.
 * @param {string} key
 * @param {*} defaultValue
 * @returns {*}
 */
export function getPreference(key, defaultValue = null) {
  try {
    const value = localStorage.getItem(`${STORAGE_PREFIX}${key}`)
    return value != null ? JSON.parse(value) : defaultValue
  } catch {
    return defaultValue
  }
}

/**
 * Set a stored preference.
 * @param {string} key
 * @param {*} value
 */
export function setPreference(key, value) {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(value))
  } catch {
    // Storage full or unavailable — ignore silently
  }
}

/**
 * Get recent calculations (most recent first).
 * @returns {Array<Object>}
 */
export function getRecentCalculations() {
  return getPreference("recent_calcs", [])
}

/**
 * Save a calculation to recent history.
 * @param {Object} params - Input params
 * @param {Object} result - Calculation result summary
 */
export function saveRecentCalculation(params, result) {
  const recent = getRecentCalculations()
  const entry = {
    params,
    gross: result.gross_salary,
    net: result.net_salary,
    timestamp: Date.now(),
  }

  recent.unshift(entry)
  setPreference("recent_calcs", recent.slice(0, MAX_RECENT))
}
